/*
 * @Author: Teemo Ding
 * @Date: 2021-07-07 17:26:57
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 14:59:25
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Order/OrderIdFormat/index.tsx
 */
import { Input, Label, NumberInput, Radio } from '@/src/components/Antd';
import Row from '@/src/components/Layouts/Row/Row';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { QuestionCircleFilled } from '@ant-design/icons';
import { Form } from 'antd';
import React, { Fragment } from 'react';
import WhiteBackgroundTooltip, {
  TooltipContainer,
  TooltipContent,
  TooltipTitle,
} from 'src/components/GlobalTooltip/WhiteBackgroundTooltip';
import css from '../css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

enum repCodeType {
  INC = 'inc',
  DEC = 'dec',
}
const OrderIdFormat = ({ disabled }: { disabled?: boolean }) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const radioList = [
    {
      value: 'Consecutive',
      label: getI18n('storeOrderSetting.detail.consecutiveNumbers'),
    },
    {
      value: 'Random',
      label: getI18n('storeOrderSetting.detail.randomNumbers'),
    },
  ];
  const repCode = (code, type) => {
    //处理编号，自动加1减1
    const nf = (code || '').match(/(\d+)([^\d]*)$/i)[1];
    return code.replace(
      /(\d+)([^\d]*)$/i,
      type == repCodeType.INC
        ? PrefixInteger(Number(nf) + 1, nf.length) + '$2'
        : PrefixInteger(Number(nf) - 1, nf.length) + '$2',
    );
  };
  const PrefixInteger = (num, n) => {
    return (Array(n).join('0') + num).slice(-n);
  };
  const getRandom = (num) => {
    const random = Math.floor(
      (Math.random() + Math.floor(Math.random() * 9 + 1)) *
        Math.pow(10, num - 1),
    );
    return random;
  };
  const renderConfig = ({
    idGenerationPolicy,
    orderNumber,
    prefix,
    suffix,
    numOfDigits,
    tail,
  }) => {
    const text = `${prefix || ''}${
      idGenerationPolicy == 'Consecutive'
        ? orderNumber || ''
        : numOfDigits
        ? getRandom(numOfDigits)
        : ''
    }${suffix || ''}`;
    return `${text}${text && tail}`;
  };
  const generateArray = (number, num) => {
    const arr = []; //容器
    for (let i = 0; i < num; i++) {
      arr.push(number);
    }
    const str = arr.join('').replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    return str;
  };

  const renderTooltip = (label, title, type) => (
    <div className={css.tooltipContainer}>
      {label}{' '}
      <WhiteBackgroundTooltip
        title={
          <TooltipContainer>
            <TooltipTitle>{title}</TooltipTitle>
            <TooltipContent>
              {type == 'orderIdPrefix' &&
                getI18n('storeOrderSetting.detail.orderPrefixTip')}
              {type == 'orderIdSuffix' &&
                getI18n('storeOrderSetting.detail.ordersuffixTip')}
              {type == 'orderNumber' &&
                getI18n('storeOrderSetting.detail.orderNoTip')}
            </TooltipContent>
          </TooltipContainer>
        }
        placement='rightTop' //overlayClassName
      >
        <QuestionCircleFilled className={css.icon} />
      </WhiteBackgroundTooltip>
    </div>
  );

  return (
    <SectionWrapper
      titleClassName={css.titleContainerAll}
      title={getI18n('storeOrderSetting.detail.orderIDFormat')}
      subtitle={getI18n('storeOrderSetting.detail.formatTip')}
      className={css.storeDetailsInfo}>
      <Form.Item
        labelCol={{
          span: 24,
        }}
        className={`${css.numberFormatRadio} ${css.orderFormatTitle}`}
        name='idGenerationPolicy'
        label={getI18n('storeOrderSetting.detail.orderNumberFormat')}>
        <Radio radioList={radioList} disabled={disabled} />
      </Form.Item>

      <Form.Item
        noStyle
        className={css.orderFormatTitle}
        shouldUpdate={(prevValues, currentValues) =>
          prevValues.idGenerationPolicy !== currentValues.idGenerationPolicy ||
          prevValues.orderNumber !== currentValues.orderNumber ||
          prevValues.numOfDigits !== currentValues.numOfDigits
        }>
        {({ getFieldValue }) =>
          getFieldValue('idGenerationPolicy') == 'Consecutive' ? (
            <Fragment>
              <Form.Item
                name='orderNumber'
                labelCol={{
                  span: 24,
                }}
                className={css.orderFormatTitle}
                label={renderTooltip(
                  `${getI18n('storeOrderSetting.detail.nextOrderNumber')}*`,
                  getI18n('storeOrderSetting.detail.nextOrderNumber'),
                  'orderNumber',
                )}
                rules={[
                  {
                    required: true,
                    message: 'Please input Next Order Number!',
                  },
                  {
                    pattern: /^\d{6,}$/,
                    message:
                      'Please input Next Order Number At least 6 digits!',
                  },
                ]}>
                <Input size='large' disabled={disabled} />
              </Form.Item>
              <span className={css.formItemSpan}>
                {getI18n('storeOrderSetting.detail.numberDisplay')}
                {/^\d*[1-9]+\d*$/.test(getFieldValue('orderNumber')) && (
                  <Fragment>
                    <span className={css.greenText}>
                      {repCode(getFieldValue('orderNumber'), repCodeType.DEC)},
                    </span>
                    <span className={css.greenText}>
                      {getFieldValue('orderNumber')},
                    </span>
                    <span className={css.greenText}>
                      {repCode(getFieldValue('orderNumber'), repCodeType.INC)}
                    </span>
                  </Fragment>
                )}
              </span>
            </Fragment>
          ) : (
            <Fragment>
              <Form.Item
                labelCol={{
                  span: 24,
                }}
                name='numOfDigits'
                label={
                  <Label
                    title={`${getI18n(
                      'storeOrderSetting.detail.orderNumberDigits',
                    )}*`}
                    rightSubTitle={`6 - 20 ${getI18n(
                      'storeOrderSetting.detail.digits',
                    )}`}
                  />
                }
                rules={[
                  {
                    required: true,
                    message: 'Please input Next Order Number!',
                  },
                  {
                    type: 'number',
                    min: 6,
                    max: 20,
                    message: 'Please input Next Order Number At 6 - 20 digits!',
                  },
                ]}>
                <NumberInput size='large' disabled={disabled} />
              </Form.Item>
              {/^[6-9]$|^1[0-9]|^20$/.test(getFieldValue('numOfDigits')) && (
                <span className={css.formItemSpan}>
                  {getI18n('storeOrderSetting.detail.atotalof')}
                  <span className={css.greenText}>
                    {generateArray(9, getFieldValue('numOfDigits'))}{' '}
                  </span>
                  {getI18n('storeOrderSetting.detail.random')}
                  <span className={css.greenText}>
                    {generateArray(9, getFieldValue('numOfDigits'))}{' '}
                  </span>
                  {getI18n('storeOrderSetting.detail.ordersuffix')}
                </span>
              )}
            </Fragment>
          )
        }
      </Form.Item>

      <Form.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) =>
          prevValues.idGenerationPolicy !== currentValues.idGenerationPolicy ||
          prevValues.orderNumber !== currentValues.orderNumber ||
          prevValues.numOfDigits !== currentValues.numOfDigits ||
          prevValues.prefix !== currentValues.prefix ||
          prevValues.suffix !== currentValues.suffix
        }>
        {({ getFieldValue }) => (
          <Fragment>
            <Row
              elements={[
                {
                  child: (
                    <Form.Item
                      labelCol={{
                        span: 24,
                      }}
                      className={css.orderFormatTitle}
                      name='prefix'
                      label={renderTooltip(
                        `${getI18n(
                          'storeOrderSetting.detail.orderIDPrefix',
                        )} (${getI18n('general.optional')})`,
                        getI18n('storeOrderSetting.detail.orderIDPrefix'),
                        'orderIdPrefix',
                      )}
                      rules={[
                        {
                          pattern: /^[0-9a-zA-Z-]{1,}$/,
                          message: getI18n('general.invalidformat'),
                        },
                      ]}>
                      <Input size='large' disabled={disabled} />
                    </Form.Item>
                  ),
                },
                {
                  child: (
                    <Form.Item
                      labelCol={{
                        span: 24,
                      }}
                      className={css.orderFormatTitle}
                      name='suffix'
                      label={renderTooltip(
                        `${getI18n(
                          'storeOrderSetting.detail.orderIDSuffix',
                        )} (${getI18n('general.optional')})`,
                        getI18n('storeOrderSetting.detail.orderIDSuffix'),
                        'orderIdSuffix',
                      )}
                      rules={[
                        {
                          pattern: /^[0-9a-zA-Z-]{1,}$/,
                          message: getI18n('general.invalidformat'),
                        },
                      ]}>
                      <Input size='large' disabled={disabled} />
                    </Form.Item>
                  ),
                },
              ]}
            />
            <span>
              {getI18n('storeOrderSetting.detail.orderdisplay')}
              <span className={css.greenText}>
                {renderConfig({
                  prefix: getFieldValue('prefix'),
                  suffix: getFieldValue('suffix'),
                  orderNumber: /^\d*[1-9]+\d*$/.test(
                    getFieldValue('orderNumber'),
                  )
                    ? repCode(getFieldValue('orderNumber'), repCodeType.DEC)
                    : '',
                  numOfDigits: getFieldValue('numOfDigits'),
                  idGenerationPolicy: getFieldValue('idGenerationPolicy'),
                  tail: ',',
                })}
                {renderConfig({
                  prefix: getFieldValue('prefix'),
                  suffix: getFieldValue('suffix'),
                  orderNumber: /^\d*[1-9]+\d*$/.test(
                    getFieldValue('orderNumber'),
                  )
                    ? getFieldValue('orderNumber')
                    : '',
                  numOfDigits: getFieldValue('numOfDigits'),
                  idGenerationPolicy: getFieldValue('idGenerationPolicy'),
                  tail: ',',
                })}
                {renderConfig({
                  prefix: getFieldValue('prefix'),
                  suffix: getFieldValue('suffix'),
                  orderNumber: /^\d*[1-9]+\d*$/.test(
                    getFieldValue('orderNumber'),
                  )
                    ? repCode(getFieldValue('orderNumber'), repCodeType.INC)
                    : '',
                  numOfDigits: getFieldValue('numOfDigits'),
                  idGenerationPolicy: getFieldValue('idGenerationPolicy'),
                  tail: '',
                })}
              </span>
            </span>
          </Fragment>
        )}
      </Form.Item>
    </SectionWrapper>
  );
};

export default OrderIdFormat;
